export default __webpack_public_path__ + "static/media/doodle_right.5bcdb314.png";